<template>
<div class="m-t-30">
  <material-progress-bar v-show="inProgress" />
  <b-row class="m-b-20">

    <b-col sm="6">
      <b-button size="lg" class="changeBtn" block @click="showChangeForm = true" v-if="!showChangeForm">Click to request some Changes</b-button>
      <b-link class="draft-form-back" href="#foo"  @click.prevent="showChangeForm = false; message = '';" v-if="showChangeForm">&laquo; Go Back to Previous Options.</b-link>
    </b-col>

    <b-col sm="12" v-if="showChangeForm" class="m-t-30">
      <section class="draft-change-form-sec">
        <div>
          <label for="" class="fieldLabel">Please write about the changes you want <span class="text-danger">*</span> (Required)</label>
          <textarea id="textarea" v-model="message" placeholder="Please explain what change do you want." v-on:input="check"></textarea>
          <p :class="{help: true, 'is-danger': remaining==0}">{{ instruction }}</p>
        </div>
        <div class="upload">
          <label for="" class="fieldLabel">Optional Image Upload</label>
          
          <div class="example-btn">
            <file-upload class="btn btn-outline-primary" :post-action="`${API_URL}customer-drafts/upload-issue-related-file`" extensions="gif,jpg,jpeg,png,webp" accept="image/png,image/gif,image/jpeg,image/webp" :multiple="false" :size="1024 * 1024 * 500" v-model="files" @input-filter="inputFilter" @input-file="inputFile" ref="upload" @input="uploadFiles" :data="{draftFileId: ids.id, draftHash: $route.params.hashCode}">
              <i class="fa fa-plus"></i>
              Select an image file
            </file-upload>
            <!-- <button type="button" class="btn btn-success" v-if="!$refs.upload || !$refs.upload.active" @click.prevent="$refs.upload.active = true">
          <i class="fa fa-arrow-up" aria-hidden="true"></i>
          Start Upload
        </button> -->
            <!-- <button type="button" class="btn btn-danger" v-else @click.prevent="$refs.upload.active = false">
          <i class="fa fa-stop" aria-hidden="true"></i>
          Stop Upload
        </button> -->
          </div>

          <ul class="m-t-20 fileUploadStatus">
            <li v-for="(file, index) in files" :key="file.id">
              <span>{{file.name}}</span> -
              <!-- <span>{{file.size | formatSize}}</span> - -->
              <span v-if="file.error">
                <b-badge variant="danger">{{file.error}}</b-badge>
              </span>
              <span v-else-if="file.success">
                <b-badge variant="primary">File Uploaded</b-badge>
              </span>
              <span v-else-if="file.active">
                <b-spinner variant="dark" label="Spinning"></b-spinner> <span class="text-dark">Please Wait</span>
              </span>
              <span v-else></span>
            </li>
          </ul>

        </div>
        <div class="clearfix">
          <b-button :variant="message ? 'danger' : 'outline-danger'" size="lg" block class="float-right draft-changes-submit-btn" :disabled="!message || ($refs.upload && $refs.upload.active == true)" @click.prevent="submitResponse('No')" :class="{'submit-btn-pulse': message}">Submit to Request Changes</b-button>
        </div>
      </section>
    </b-col>

    <b-col sm="6" v-if="!showChangeForm">
      <b-button size="lg" block class="orange-btn approveBtn" @click.prevent="submitResponse('Yes')">Click to Approve the Artwork.</b-button>
    </b-col>

  </b-row>

  <p v-if="!showChangeForm">{{ draftType == 'digital_print' ? 'You can download your finished artwork' : draftType == 'physical_canvas' ? 'We will proceed with canvas printing' : 'We will proceed with the order' }} once you click and approve by clicking on "I approve the artwork" button. </p>

</div>
</template>

<script>
import CustomerDraftsService from '../../../services/customer-drafts.service';
import FileUpload from 'vue-upload-component'
const MaterialProgressBar = () => import( /* webpackChunkName: "material-progress-bar" */ "../../../components/common/material-progress-bar")
import {
  API_URL
} from '../../../services/constants'

import EventBus from '../../../EventBus'

export default {
  data() {
    return {
      message: '',
      limit: 500,
      showChangeForm: false,
      inProgress: false,
      files: [],
      API_URL: API_URL,
    }
  },
  components: {
    FileUpload,
    MaterialProgressBar,
    MaterialProgressBar
  },
  props: {
    ids: {
      type: Object,
      default: () => ({})
    },
    draftType: {
      type: String,
      default: ''
    }
  },
  methods: {
    check: function () {
      this.message = this.message.substr(0, this.limit)
    },
    async submitResponse(approvalStatus) {
      let that = this;
      
      let confirmMessage = approvalStatus == 'Yes' ? 'No further changes can be done after approval. Click proceed to approve artwork.' : approvalStatus == 'No' ? 'Any request for changes will further delay the order. Click proceed to request changes.' : 'Click proceed to confirm'
    
        this.$dialog
          .confirm(confirmMessage, {
             okText: 'Proceed',
             cancelText: 'Cancel',
          })
          .then(async function(dialog) {
            console.log("Submit it.")
            await that.submitToAPI(approvalStatus);
          })
          .catch(function(e) {
            console.log('Clicked on cancel', e);
        });
    },
    async submitToAPI(approvalStatus){  
      let data = {
        approvalStatus,
        customerMessage: this.message,
        id: this.ids.id,
        customerDraftId: this.ids.customerDraftId
      }
      try {
        this.inProgress = true;
        const postCustomerResponse = await CustomerDraftsService.postCustomerResponseForDraft(data);
        this.inProgress = false;
        EventBus.$emit("customer-responded-on-draft");
      } catch (e) {
        this.inProgress = false;
        console.log(e)
      }
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Before adding a file
        // Filter system files or hide files
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent()
        }
        // Filter php html js file
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent()
        }
      }
    },
    inputFile(newFile, oldFile) {
      if (newFile && !oldFile) {
        // add
        console.log('add', newFile)
      }
      if (newFile && oldFile) {
        // update
        console.log('update', newFile)
      }
      if (!newFile && oldFile) {
        // remove
        console.log('remove', oldFile)
      }
    },
    uploadFiles() {
      this.$refs.upload.active = true
    },
    showChangeFormFn() {
      console.log("Show the change form");
      this.showChangeForm = !this.showChangeForm
    }
  },
  computed: {
    instruction: function () {
      return this.message == '' ?
        'limit: ' + this.limit + ' characters' :
        'remaining ' + this.remaining + ' characters';
    },
    remaining: function () {
      return this.limit - this.message.length;
    },
    anyActiveUploads() {
      this.files.forEach(file => {
        if (file.active) {
          return true;
        }
      })
      return false;
    }
  },
}
</script>

<style lang="scss" scoped>
$orangeColor: rgb(255, 95, 21);


.fieldLabel {
  font-size: 15px;
  font-weight: 500;
}

#textarea {
  display: block;
  width: 100%;
  min-height: 160px;
  border: 1px solid rgb(206, 206, 206);
  border-radius: 5px;
  padding: 15px;
}

.is-danger {
  color: rgb(253, 45, 45);
}

.orange-btn {
  color: #fff;
  background-color: $orangeColor;
  border-color: $orangeColor;

  &:active {
    background-color: $orangeColor !important;
    color: #fff !important;
  }
}
.draft-changes-submit-btn{
   text-transform: uppercase;
   font-size: 16px;
   
}
.submit-btn-pulse{
  animation: pulse 2s infinite;
}
.draft-form-back{
   font-size: 15px;
   color: rgb(124, 124, 124);
}
.draft-change-form-sec{
   border-top: 1px solid rgb(226, 226, 226);
   padding-top: 20px;
}
@-webkit-keyframes pulse {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(255, 0, 23, 0.7);
  }
  70% {
      -webkit-box-shadow: 0 0 0 10px rgba(255, 0, 23, 0);
  }
  100% {
      -webkit-box-shadow: 0 0 0 0 rgba(255, 0, 23, 0);
  }
}
@keyframes pulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(255, 0, 23, 0.7);
    box-shadow: 0 0 0 0 rgba(255, 0, 23, 0.7);
  }
  70% {
      -moz-box-shadow: 0 0 0 10px rgba(255, 0, 23, 0);
      box-shadow: 0 0 0 10px rgba(255, 0, 23, 0);
  }
  100% {
      -moz-box-shadow: 0 0 0 0 rgba(255, 0, 23, 0);
      box-shadow: 0 0 0 0 rgba(255, 0, 23, 0);
  }
}

@media only screen and (max-width: 767px) {
  .approveBtn {
    margin-bottom: 30px;
  }

  .changeBtn {
    margin-bottom: 20px;
  }
}

.fileUploadStatus {
  padding-left: 0;
  list-style: none;

  li {
    border: 1px dashed rgb(218, 218, 218);
    border-radius: 5px;
    padding: 5px 10px;
  }
}

</style>
